import axiosInstance from './axiosConfig';

import { logger } from "utils/logger";
export interface FileUploadConfig {
  max_file_size: number | null;
  max_file_size_mb: number | null;
  max_files_count: number;
  allowed_extensions: string[];
  allowed_mime_types: string[];
}

class FileUploadConfigService {
  private config: FileUploadConfig | null = null;
  private configPromise: Promise<FileUploadConfig> | null = null;

  async getConfig(): Promise<FileUploadConfig> {
    if (this.config) {
      return this.config;
    }

    if (this.configPromise) {
      return this.configPromise;
    }

    this.configPromise = this.fetchConfig();
    this.config = await this.configPromise;
    return this.config;
  }

  private async fetchConfig(): Promise<FileUploadConfig> {
    try {
      const response = await axiosInstance.get('/courses/file-upload-config/');
      return response.data;
    } catch (error) {
      logger.error('Failed to fetch file upload config:', error);
      // Fallback к значениям по умолчанию
      return {
        max_file_size: null,
        max_file_size_mb: null,
        max_files_count: 10,
        allowed_extensions: ['.pdf', '.doc', '.docx', '.txt', '.jpg', '.jpeg', '.png', '.gif', '.mp4', '.avi', '.mov'],
        allowed_mime_types: [
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'text/plain',
          'image/jpeg',
          'image/png',
          'image/gif',
          'video/mp4',
          'video/avi',
          'video/quicktime'
        ]
      };
    }
  }

  // Метод для сброса кэша (полезно для тестирования)
  resetCache(): void {
    this.config = null;
    this.configPromise = null;
  }
}

export const fileUploadConfigService = new FileUploadConfigService();
